/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAccountHandle.defs.js'
export * as $defs from './updateAccountHandle.defs.js'
